import React, { FC } from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import useMountEffect from '../../hooks/useMountEffect';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import PermissionDeniedPage from '../permission_denied_page/PermissionDeniedPage';
import SpotPurchasesSectionInWorkOrder from '../supplier_work_orders_detail_charges_page/SpotPurchasesSectionInWorkOrder';
import { workOrdersRestCrudThunksForBuyer } from '../../thunks/work_orders_thunks';
import { getEntityById, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';

const { Content } = Layout;

interface WorkOrdersDetailSpotPurchasesPageProps {
	match: any;
	workOrder: any;
	workOrdersFetching: boolean;
	companyConfig: any;
	getWorkOrder: (workOrderId: number | string) => Promise<any>;
}

const WorkOrdersDetailSpotPurchasesPage: FC<WorkOrdersDetailSpotPurchasesPageProps> = ({
	match,
	workOrder,
	workOrdersFetching,
	companyConfig,
	getWorkOrder,
}) => {
	const workOrderId = match.params.id;

	useMountEffect(() => {
		if (!nullSafeGet('id', workOrder)) {
			getWorkOrder(workOrderId);
		}
	});

	// The tab is hidden when the company has spot purchases turned off, but the route is still
	// reachable by URL, so the flag has to be re-checked here. Keep this path and default in sync
	// with the tab gate in WorkOrdersDetailPage — if they disagree, the tab renders but the page
	// denies. Backed by BuyerConfig.spotPurchasesConfig.enableSpotPurchases, which defaults false.
	const spotPurchasesEnabled = nullSafeGetOrElse(
		'config.spotPurchasesConfig.enableSpotPurchases',
		companyConfig,
		false
	);

	if (!spotPurchasesEnabled) {
		return <PermissionDeniedPage />;
	}

	if (workOrdersFetching && !nullSafeGet('id', workOrder)) {
		return <PageLoadingPlaceholder />;
	}

	return (
		<Content className="workOrdersDetailSpotPurchasesPage" style={{ padding: '0 0.5em' }}>
			<div className="rowSpacing">
				<SpotPurchasesSectionInWorkOrder workOrder={workOrder} userType={ROLE_TYPES.BUYER} />
			</div>
		</Content>
	);
};

const mapStateToProps = (state: any, ownProps: any) => ({
	match: ownProps.match,
	workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
	workOrdersFetching: state.work_orders.fetching,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch: any) => ({
	getWorkOrder: (workOrderId: number | string) =>
		dispatch(workOrdersRestCrudThunksForBuyer.readOne(workOrderId)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(WorkOrdersDetailSpotPurchasesPage)
);
